<template>
  <div class="topBar flex w-full h-16 justify-between bg-white  text-costeaPrimary z-10">
    <div class="flex">
      <button @click="extendMenu()"
        class="flex items-center text-t20 justify-center py-4 w-16 mr-4 hover:bg-costeaBtn2 hover:text-costeaPrimary">
        <i class="ri-menu-2-line"></i>
      </button>
      <img class="w-28 " src="https://app.costea.com.co/img/costea-logo-finanzas-colombia.svg" :alt="costea.logoAlt">
    </div>
    <div class="flex flex-row justify-end items-center text-costeaDarkGray">
      <!--:to="{name: 'profile'}"-->
      <div class="flex justify-center items-center cursor-pointer h-full hover:text-costeaPrimary">
        <img class="w-8 mr-2 rounded-md hidden md:block" :src="showImage(user.picture)" alt="">
        <div class="flex flex-col ml-5">
          <p class="mr-3 text-t14 font-costea">{{ user.name }}</p>
          <p class="mr-3 text-t14 font-costea">{{ userRole }}</p>
        </div>
      </div>
      <button @click="logout()"
        class="flex items-center text-h24 justify-center py-4 w-14 hover:bg-costeaBtn2 hover:text-costeaPrimary">
        <i class="ri-logout-circle-r-line"></i>
      </button>
    </div>
  </div>
</template>


<script>
import { mapMutations, mapState } from 'vuex'
// import axios from 'axios'
export default {
  name: 'TopBar',
  data() {
  return {
    user: {
      name: null,
      role_id: null,
    },
    secretWord: localStorage.getItem('secret-word')
  }
},

  methods: {
    ...mapMutations(['extendMenu']),
    logout() {
      //axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}logout`).then(() =>{this.$router.push('/login'); localStorage.clear()}).catch(error =>{console.log(error)})
      localStorage.clear()
      this.$router.push('/login')
    },
    getUsuario() {

      this.user.name =  localStorage.getItem('name')
      this.user.role_id  = localStorage.getItem('rol_usuario')
      // const config = {
      //   headers: {
      //     'Content-Type': 'multipart/form-data'
      //   }
      // }
      // axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}users`, config)
      //   .then(response => {
      //     let data = response.data;
      //     this.user = data.filter(data => {
      //       return data.email === localStorage.getItem('email')
      //     })
          
      //   })
      //   .catch(error => {
      //     console.log(error)
      //   });
    },
    // getUsuario() {
    //   const config = {
    //     headers: {
    //       'Content-Type': 'multipart/form-data'
    //     }
    //   }
    //   axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}users`, config)
    //     .then(response => {
    //       let data = response.data;
    //       this.user = data.filter(data => {
    //         return data.email === localStorage.getItem('email')
    //       })
          
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     });
    // },
    showImage(imagen) {
      
      if (imagen != null) {
        return this.costea.protocol + this.secretWord + '.backend.costea.com.co/' + imagen
      } else {
        return 'https://app.costea.com.co/img/perfilCostea.png'
      }
    },
  },
  computed: {
  ...mapState(['costea']),
  userRole() {
    if (this.user.role_id == 1) return "SuperAdmin";
    if (this.user.role_id == 2) return "Admin";
    return "Consulta";
  },
},
  beforeMount() {
    this.getUsuario()
  }
}

</script>

<style>
.topBar {
  z-index: 10;
  box-shadow: 0 8px 20px -15px rgba(8, 10, 15, 0.15);
}
</style>